// React
import React from "react";
import PropTypes from "prop-types";

function TableHeader({ title }) {
  return (
    <header role="heading" className="ui-sortable-handle">
      <span className="widget-icon">
        <i className="fa fa-table" />
      </span>
      <h2>{title}</h2>
    </header>
  );
}

TableHeader.defaultProps = {
  title: ""
};

TableHeader.propTypes = {
  title: PropTypes.string
};

export default TableHeader;
